import * as ScrollArea from '@radix-ui/react-scroll-area';
import clx from 'classnames';
import { useController, useFormContext } from 'react-hook-form';
import { VisualOptions } from 'types/forms';
import { ErrorLabel, Label } from '../../labels';
import VisualRadio from '../VisualRadio';
import { ChangeEventHandler } from 'react';

const VisualRadioList = ({
  options,
  name,
  title,
  supportingText,
  required,
  isFullWidth = false,
  hideErrorMsg = false,
  onChange,
}: {
  options: VisualOptions;
  name: string;
  title?: string;
  supportingText?: string | null;
  required?: boolean;
  isFullWidth?: boolean;
  onChange?: (s: string) => void;
  hideErrorMsg?: boolean;
}) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error, invalid },
  } = useController({
    name,
    control,
  });

  const handleChange: ChangeEventHandler<HTMLInputElement> = ({ target: { value } }) => {
    field.onChange(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className={clx('m-auto flex flex-col gap-2', isFullWidth ? 'w-full' : 'w-fit max-w-full ')}>
      {title && <Label isInvalid={invalid} label={title} name={name} required={required} />}
      {supportingText && (
        <label className="md-regular text-neutral-400" htmlFor={name}>
          {supportingText}
          {required && !title && <span className="md-bold">*</span>}
        </label>
      )}
      <ScrollArea.Root>
        <ScrollArea.Viewport>
          <ul className={clx('flex items-stretch gap-2 max-w-full m-auto', isFullWidth ? 'w-full' : 'w-fit ')}>
            {Object.entries(options).map(([id, option]) => (
              <li key={id} className={clx('first:ml-auto last:mr-auto', isFullWidth ? 'w-full' : 'shrink-0')}>
                <VisualRadio
                  {...option}
                  checked={field.value === id}
                  field={field}
                  id={`${name}-${id}`}
                  name={name}
                  onChange={handleChange}
                  value={id}
                  isFullWidth
                />
              </li>
            ))}
          </ul>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar orientation="horizontal">
          <ScrollArea.Thumb />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
      {invalid && !hideErrorMsg && <ErrorLabel className="w-full" error={error?.message} />}
    </div>
  );
};
export default VisualRadioList;
